import React, { Component } from 'react';
import axios from 'axios';
import moment from 'moment';
import * as ReactBootStrap from 'react-bootstrap';
import { store } from 'react-notifications-component';
import $ from 'jquery';
import 'bootstrap';

import EstadoVacio from '../components/EstadoVacio';
import '../tools/css/CuentasCobro.css';

const ApiURL = process.env.REACT_APP_API_URL;

const ESTADOS_INFO = {
  'creada': { etiqueta: 'Creada', clase: 'ccobro-badge--creada' },
  'en-proceso': { etiqueta: 'En proceso', clase: 'ccobro-badge--proceso' },
  'enviada': { etiqueta: 'Enviada', clase: 'ccobro-badge--enviada' },
  'radicada': { etiqueta: 'Radicada', clase: 'ccobro-badge--radicada' },
  'cancelada': { etiqueta: 'Cancelada', clase: 'ccobro-badge--cancelada' }
};

const formInicialCrear = () => ({ idContrato: '', descripcion: '' });
const formInicialRadicar = () => ({ numeroRadicado: '', fechaRadicado: '', observacion: '' });

class CuentasCobro extends Component {

  constructor() {
    super();
    this.state = {
      cargandoLista: false,
      cuentas: [],
      pagerItems: [],
      pagerInfo: '',
      paginaActual: 1,
      contratos: [],
      filtros: { idContrato: '', estado: '', desde: '', hasta: '' },

      mostrarModalCrear: false,
      formCrear: formInicialCrear(),
      guardandoCrear: false,

      mostrarModalDetalle: false,
      cargandoDetalle: false,
      cuentaActual: null,
      tabDetalle: 'facturas',

      editandoDescripcion: false,
      descripcionEdit: '',
      guardandoEditar: false,

      facturasCuenta: [],
      cargandoFacturasCuenta: false,
      quitandoFacturaId: null,

      facturasDisponibles: [],
      pagerFacturasDisponibles: [],
      pagerInfoFacturasDisponibles: '',
      paginaFacturasDisponibles: 1,
      textoBuscarDisponibles: '',
      cargandoFacturasDisponibles: false,
      facturasSeleccionadas: [],
      guardandoAgregarFacturas: false,

      historialCuenta: [],
      cargandoHistorial: false,

      motivoCancelar: '',
      guardandoCancelar: false,

      observacionEnviar: '',
      guardandoEnviar: false,

      formRadicar: formInicialRadicar(),
      guardandoRadicar: false
    };
  }

  componentDidMount() {
    this.cargarContratos();
    this.cargarCuentas(1);
  }

  notificar = (titulo, mensaje, tipo) => {
    store.addNotification({
      title: titulo,
      message: mensaje,
      type: tipo,
      container: 'top-right',
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 10000, showIcon: true }
    });
  }

  /** Devuelve el primer valor no vacío probando varias rutas posibles (ej. "contrato.name" o "nombreContrato"), ya que el swagger no documenta el shape exacto de las respuestas de este controller. */
  campo = (obj, rutas, porDefecto) => {
    for (let i = 0; i < rutas.length; i++) {
      const valor = rutas[i].split('.').reduce((acc, clave) => (acc && acc[clave] !== undefined ? acc[clave] : undefined), obj);
      if (valor !== undefined && valor !== null && valor !== '') return valor;
    }
    return porDefecto !== undefined ? porDefecto : '';
  }

  formatearFecha = (valor, formato) => (valor ? moment(valor).format(formato || 'DD/MM/YYYY') : '');

  renderBadgeEstado = (estado) => {
    const info = ESTADOS_INFO[estado] || { etiqueta: estado || 'Sin estado', clase: 'ccobro-badge--creada' };
    return <span className={"ccobro-badge " + info.clase}>{info.etiqueta}</span>;
  }

  cargarContratos = () => {
    axios.get(ApiURL + "/api/Contracts/List")
      .then((response) => {
        const lista = (response.data && response.data.data) || response.data || [];
        this.setState({ contratos: lista.map((c) => ({ id: c.id, nombre: c.name || c.nombre })) });
      })
      .catch((error) => console.log(error));
  }

  cargarCuentas = (pagina) => {
    this.setState({ cargandoLista: true, paginaActual: pagina });
    const f = this.state.filtros;

    axios.get(ApiURL + "/api/CuentasCobro/List", {
      params: {
        numeroPagina: pagina,
        idContrato: f.idContrato || undefined,
        estado: f.estado || undefined,
        desde: f.desde || undefined,
        hasta: f.hasta || undefined
      }
    })
      .then((response) => {
        console.log('CuentasCobro/List:', response.data);
        const data = response.data || {};
        const lista = data.data || data.items || (Array.isArray(data) ? data : []);
        const pager = data.pager || {};
        this.setState({
          cuentas: lista,
          pagerItems: pager.items || [],
          pagerInfo: pager.showData || '',
          cargandoLista: false
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ cargandoLista: false, cuentas: [] });
      });
  }

  handleFiltro = (e) => {
    this.setState({ filtros: { ...this.state.filtros, [e.target.name]: e.target.value } });
  }

  aplicarFiltros = () => {
    this.cargarCuentas(1);
  }

  limpiarFiltros = () => {
    this.setState({ filtros: { idContrato: '', estado: '', desde: '', hasta: '' } }, () => this.cargarCuentas(1));
  }

  // ---------------------------------------------------------------- Crear --

  abrirModalCrear = () => {
    this.setState({ formCrear: formInicialCrear() }, () => {
      $('#modal-crear-cuenta-cobro').modal('show');
    });
  }

  handleChangeCrear = (e) => {
    this.setState({ formCrear: { ...this.state.formCrear, [e.target.name]: e.target.value } });
  }

  guardarCrear = () => {
    const { formCrear } = this.state;
    if (!formCrear.idContrato) {
      this.notificar('Atención', 'Selecciona el contrato sobre el que se creará la cuenta de cobro', 'danger');
      return;
    }

    this.setState({ guardandoCrear: true });
    axios.post(ApiURL + "/api/CuentasCobro/Create", {
      idContrato: Number(formCrear.idContrato),
      descripcion: formCrear.descripcion || null
    })
      .then(() => {
        this.notificar('Mensaje', 'La cuenta de cobro se creó correctamente', 'success');
        this.setState({ guardandoCrear: false });
        $('#modal-crear-cuenta-cobro').modal('hide');
        this.cargarCuentas(1);
      })
      .catch((error) => {
        const mensaje = (error.response && error.response.data && (error.response.data.message || error.response.data.title)) || 'No se pudo crear la cuenta de cobro';
        this.notificar('Atención', mensaje, 'danger');
        this.setState({ guardandoCrear: false });
      });
  }

  // --------------------------------------------------------------- Detalle --

  abrirDetalle = (cuenta) => {
    const id = this.campo(cuenta, ['id'], null);
    this.setState({
      mostrarModalDetalle: true,
      cuentaActual: cuenta,
      tabDetalle: 'facturas',
      editandoDescripcion: false,
      facturasSeleccionadas: []
    }, () => {
      $('#modal-detalle-cuenta-cobro').modal('show');
      this.cargarDetalle(id);
      this.cargarFacturasCuenta(id);
    });
  }

  cerrarDetalle = () => {
    $('#modal-detalle-cuenta-cobro').modal('hide');
    this.setState({ cuentaActual: null, facturasCuenta: [], historialCuenta: [], facturasDisponibles: [] });
  }

  cargarDetalle = (id) => {
    if (!id) return;
    this.setState({ cargandoDetalle: true });
    axios.get(ApiURL + "/api/CuentasCobro/" + id)
      .then((response) => {
        console.log('CuentasCobro/{id}:', response.data);
        this.setState({ cuentaActual: response.data, cargandoDetalle: false, descripcionEdit: this.campo(response.data, ['descripcion'], '') });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ cargandoDetalle: false });
      });
  }

  cambiarTabDetalle = (tab) => {
    this.setState({ tabDetalle: tab });
    const id = this.campo(this.state.cuentaActual, ['id'], null);
    if (tab === 'agregar') this.cargarFacturasDisponibles(1);
    if (tab === 'historial') this.cargarHistorial(id);
  }

  // ------------------------------------------------------- Editar descripción --

  iniciarEdicionDescripcion = () => {
    this.setState({ editandoDescripcion: true, descripcionEdit: this.campo(this.state.cuentaActual, ['descripcion'], '') });
  }

  guardarDescripcion = () => {
    const id = this.campo(this.state.cuentaActual, ['id'], null);
    if (!id) return;

    this.setState({ guardandoEditar: true });
    axios.put(ApiURL + "/api/CuentasCobro/Edit/" + id, { descripcion: this.state.descripcionEdit || null })
      .then(() => {
        this.notificar('Mensaje', 'Descripción actualizada', 'success');
        this.setState({ guardandoEditar: false, editandoDescripcion: false });
        this.cargarDetalle(id);
        this.cargarCuentas(this.state.paginaActual);
      })
      .catch((error) => {
        const mensaje = (error.response && error.response.data && (error.response.data.message || error.response.data.title)) || 'No se pudo editar la descripción';
        this.notificar('Atención', mensaje, 'danger');
        this.setState({ guardandoEditar: false });
      });
  }

  // ------------------------------------------------------ Facturas de la cuenta --

  cargarFacturasCuenta = (id) => {
    if (!id) return;
    this.setState({ cargandoFacturasCuenta: true });
    axios.get(ApiURL + "/api/CuentasCobro/" + id + "/Facturas")
      .then((response) => {
        console.log('CuentasCobro/{id}/Facturas:', response.data);
        const data = response.data || {};
        const lista = data.data || (Array.isArray(data) ? data : []);
        this.setState({ facturasCuenta: lista, cargandoFacturasCuenta: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ cargandoFacturasCuenta: false, facturasCuenta: [] });
      });
  }

  quitarFactura = (idDocumento) => {
    const id = this.campo(this.state.cuentaActual, ['id'], null);
    if (!id) return;

    this.setState({ quitandoFacturaId: idDocumento });
    axios.delete(ApiURL + "/api/CuentasCobro/" + id + "/Facturas/" + idDocumento)
      .then(() => {
        this.notificar('Mensaje', 'Factura retirada de la cuenta', 'success');
        this.setState({ quitandoFacturaId: null });
        this.cargarFacturasCuenta(id);
        this.cargarDetalle(id);
        this.cargarCuentas(this.state.paginaActual);
      })
      .catch((error) => {
        const mensaje = (error.response && error.response.data && (error.response.data.message || error.response.data.title)) || 'No se pudo retirar la factura';
        this.notificar('Atención', mensaje, 'danger');
        this.setState({ quitandoFacturaId: null });
      });
  }

  // ------------------------------------------------------- Facturas disponibles --

  cargarFacturasDisponibles = (pagina) => {
    const cuenta = this.state.cuentaActual;
    const idContrato = this.campo(cuenta, ['idContrato', 'contrato.id'], null);
    if (!idContrato) return;

    this.setState({ cargandoFacturasDisponibles: true, paginaFacturasDisponibles: pagina });
    axios.get(ApiURL + "/api/CuentasCobro/FacturasDisponibles", {
      params: { idContrato: idContrato, texto: this.state.textoBuscarDisponibles || undefined, numeroPagina: pagina }
    })
      .then((response) => {
        console.log('CuentasCobro/FacturasDisponibles:', response.data);
        const data = response.data || {};
        const lista = data.data || (Array.isArray(data) ? data : []);
        const pager = data.pager || {};
        this.setState({
          facturasDisponibles: lista,
          pagerFacturasDisponibles: pager.items || [],
          pagerInfoFacturasDisponibles: pager.showData || '',
          cargandoFacturasDisponibles: false
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ cargandoFacturasDisponibles: false, facturasDisponibles: [] });
      });
  }

  buscarFacturasDisponibles = () => {
    this.cargarFacturasDisponibles(1);
  }

  toggleFacturaSeleccionada = (idDocumento) => {
    this.setState((previo) => {
      const seleccionadas = previo.facturasSeleccionadas.includes(idDocumento)
        ? previo.facturasSeleccionadas.filter((id) => id !== idDocumento)
        : previo.facturasSeleccionadas.concat([idDocumento]);
      return { facturasSeleccionadas: seleccionadas };
    });
  }

  agregarFacturasSeleccionadas = () => {
    const id = this.campo(this.state.cuentaActual, ['id'], null);
    if (!id || this.state.facturasSeleccionadas.length === 0) {
      this.notificar('Atención', 'Selecciona al menos una factura para agregar', 'danger');
      return;
    }

    this.setState({ guardandoAgregarFacturas: true });
    axios.post(ApiURL + "/api/CuentasCobro/" + id + "/Facturas", { idDocumentos: this.state.facturasSeleccionadas })
      .then(() => {
        this.notificar('Mensaje', 'Facturas agregadas a la cuenta', 'success');
        this.setState({ guardandoAgregarFacturas: false, facturasSeleccionadas: [], tabDetalle: 'facturas' });
        this.cargarFacturasCuenta(id);
        this.cargarDetalle(id);
        this.cargarCuentas(this.state.paginaActual);
      })
      .catch((error) => {
        const mensaje = (error.response && error.response.data && (error.response.data.message || error.response.data.title)) || 'No se pudieron agregar las facturas seleccionadas';
        this.notificar('Atención', mensaje, 'danger');
        this.setState({ guardandoAgregarFacturas: false });
      });
  }

  // --------------------------------------------------------------- Historial --

  cargarHistorial = (id) => {
    if (!id) return;
    this.setState({ cargandoHistorial: true });
    axios.get(ApiURL + "/api/CuentasCobro/" + id + "/Historial")
      .then((response) => {
        console.log('CuentasCobro/{id}/Historial:', response.data);
        const data = response.data || {};
        const lista = data.data || (Array.isArray(data) ? data : []);
        this.setState({ historialCuenta: lista, cargandoHistorial: false });
      })
      .catch((error) => {
        console.log(error);
        this.setState({ cargandoHistorial: false, historialCuenta: [] });
      });
  }

  // ------------------------------------------------------------------ Enviar --

  enviarCuenta = () => {
    const id = this.campo(this.state.cuentaActual, ['id'], null);
    if (!id) return;

    this.setState({ guardandoEnviar: true });
    axios.post(ApiURL + "/api/CuentasCobro/Enviar/" + id, { observacion: this.state.observacionEnviar || null })
      .then(() => {
        this.notificar('Mensaje', 'La cuenta de cobro se envió correctamente', 'success');
        this.setState({ guardandoEnviar: false, observacionEnviar: '' });
        $('#modal-enviar-cuenta-cobro').modal('hide');
        this.cargarDetalle(id);
        this.cargarCuentas(this.state.paginaActual);
      })
      .catch((error) => {
        const mensaje = (error.response && error.response.data && (error.response.data.message || error.response.data.title)) || 'No se pudo enviar la cuenta de cobro';
        this.notificar('Atención', mensaje, 'danger');
        this.setState({ guardandoEnviar: false });
      });
  }

  // ----------------------------------------------------------------- Radicar --

  abrirRadicar = () => {
    this.setState({ formRadicar: formInicialRadicar() }, () => $('#modal-radicar-cuenta-cobro').modal('show'));
  }

  handleChangeRadicar = (e) => {
    this.setState({ formRadicar: { ...this.state.formRadicar, [e.target.name]: e.target.value } });
  }

  confirmarRadicar = () => {
    const id = this.campo(this.state.cuentaActual, ['id'], null);
    const { formRadicar } = this.state;
    if (!id || !formRadicar.numeroRadicado) {
      this.notificar('Atención', 'Ingresa el número de radicado', 'danger');
      return;
    }

    this.setState({ guardandoRadicar: true });
    axios.post(ApiURL + "/api/CuentasCobro/Radicar/" + id, {
      numeroRadicado: formRadicar.numeroRadicado,
      fechaRadicado: formRadicar.fechaRadicado || null,
      observacion: formRadicar.observacion || null
    })
      .then(() => {
        this.notificar('Mensaje', 'La cuenta de cobro se radicó correctamente', 'success');
        this.setState({ guardandoRadicar: false });
        $('#modal-radicar-cuenta-cobro').modal('hide');
        this.cargarDetalle(id);
        this.cargarFacturasCuenta(id);
        this.cargarCuentas(this.state.paginaActual);
      })
      .catch((error) => {
        const mensaje = (error.response && error.response.data && (error.response.data.message || error.response.data.title)) || 'No se pudo radicar la cuenta de cobro';
        this.notificar('Atención', mensaje, 'danger');
        this.setState({ guardandoRadicar: false });
      });
  }

  // ---------------------------------------------------------------- Cancelar --

  abrirCancelar = () => {
    this.setState({ motivoCancelar: '' }, () => $('#modal-cancelar-cuenta-cobro').modal('show'));
  }

  confirmarCancelar = () => {
    const id = this.campo(this.state.cuentaActual, ['id'], null);
    if (!id || !this.state.motivoCancelar.trim()) {
      this.notificar('Atención', 'El motivo de cancelación es obligatorio', 'danger');
      return;
    }

    this.setState({ guardandoCancelar: true });
    axios.post(ApiURL + "/api/CuentasCobro/Cancelar/" + id, { motivo: this.state.motivoCancelar })
      .then(() => {
        this.notificar('Mensaje', 'La cuenta de cobro se canceló', 'success');
        this.setState({ guardandoCancelar: false });
        $('#modal-cancelar-cuenta-cobro').modal('hide');
        this.cargarDetalle(id);
        this.cargarCuentas(this.state.paginaActual);
      })
      .catch((error) => {
        const mensaje = (error.response && error.response.data && (error.response.data.message || error.response.data.title)) || 'No se pudo cancelar la cuenta de cobro';
        this.notificar('Atención', mensaje, 'danger');
        this.setState({ guardandoCancelar: false });
      });
  }

  render() {
    const { cuentaActual } = this.state;
    const estado = cuentaActual ? this.campo(cuentaActual, ['estado'], '') : '';
    const puedeEditar = estado === 'creada' || estado === 'en-proceso';
    const puedeAgregarFacturas = estado === 'creada' || estado === 'en-proceso';
    const puedeEnviar = estado === 'en-proceso';
    const puedeRadicar = estado === 'enviada';
    const puedeCancelar = estado === 'creada' || estado === 'en-proceso';

    return (
      <div className="content-wrapper ccobro-wrapper">
        <section className="content-header">
          <div className="container-fluid">
            <div className="row mb-2 align-items-center">
              <div className="col-sm-6">
                <h1><i className="fas fa-file-invoice-dollar"></i> Cuentas de cobro</h1>
              </div>
              <div className="col-sm-6 text-right">
                <button type="button" className="btn ccobro-btn-crear" onClick={this.abrirModalCrear}>
                  <i className="fas fa-plus"></i> Crear cuenta de cobro
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid">

            <div className="ccobro-filtros">
              <div className="row align-items-end">
                <div className="col-md-3">
                  <label>Contrato</label>
                  <select className="form-control" name="idContrato" value={this.state.filtros.idContrato} onChange={this.handleFiltro}>
                    <option value="">Todos</option>
                    {this.state.contratos.map((c) => <option key={c.id} value={c.id}>{c.nombre}</option>)}
                  </select>
                </div>
                <div className="col-md-2">
                  <label>Estado</label>
                  <select className="form-control" name="estado" value={this.state.filtros.estado} onChange={this.handleFiltro}>
                    <option value="">Todos</option>
                    <option value="creada">Creada</option>
                    <option value="en-proceso">En proceso</option>
                    <option value="enviada">Enviada</option>
                    <option value="radicada">Radicada</option>
                    <option value="cancelada">Cancelada</option>
                  </select>
                </div>
                <div className="col-md-2">
                  <label>Desde</label>
                  <input type="date" className="form-control" name="desde" value={this.state.filtros.desde} onChange={this.handleFiltro}/>
                </div>
                <div className="col-md-2">
                  <label>Hasta</label>
                  <input type="date" className="form-control" name="hasta" value={this.state.filtros.hasta} onChange={this.handleFiltro}/>
                </div>
                <div className="col-md-3 ccobro-filtros__botones">
                  <button type="button" className="btn ccobro-btn-ghost" onClick={this.aplicarFiltros}><i className="fas fa-search"></i> Buscar</button>
                  <button type="button" className="btn ccobro-btn-ghost" onClick={this.limpiarFiltros}><i className="fas fa-times"></i> Limpiar</button>
                </div>
              </div>
            </div>

            <div className="card ccobro-card">
              <div className="card-body">

                {this.state.cargandoLista ? (
                  <div className="ccobro-cargando"><ReactBootStrap.Spinner animation="border"/> <span>Cargando cuentas de cobro...</span></div>
                ) : this.state.cuentas.length === 0 ? (
                  <div className="d-flex justify-content-center"><div className="estado-vacio__wrap"><EstadoVacio/></div></div>
                ) : (
                  <React.Fragment>
                    <div className="table-responsive">
                      <table className="table table-hover ccobro-table">
                        <thead>
                          <tr>
                            <th>ID</th>
                            <th>Contrato</th>
                            <th>Descripción</th>
                            <th>Estado</th>
                            <th>Fecha creación</th>
                            <th>Facturas</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.cuentas.map((cuenta) => (
                            <tr key={this.campo(cuenta, ['id'])}>
                              <td>{this.campo(cuenta, ['id'])}</td>
                              <td>{this.campo(cuenta, ['contrato.name', 'contrato.nombre', 'nombreContrato', 'contrato'], '-')}</td>
                              <td>{this.campo(cuenta, ['descripcion'], '-')}</td>
                              <td>{this.renderBadgeEstado(this.campo(cuenta, ['estado']))}</td>
                              <td>{this.formatearFecha(this.campo(cuenta, ['fechaCreacion', 'fecha']), 'DD/MM/YYYY HH:mm')}</td>
                              <td>{this.campo(cuenta, ['totalFacturas', 'cantidadFacturas'], '-')}</td>
                              <td className="text-right">
                                <button type="button" className="btn ccobro-btn-ver" onClick={()=> this.abrirDetalle(cuenta)}>
                                  <i className="fas fa-eye"></i> Ver
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    <div className="ccobro-pagination-bar">
                      <span className="ccobro-pager-info">{this.state.pagerInfo}</span>
                      <nav className="nav ccobro-pagination">
                        <ul className="pagination">
                          {this.state.pagerItems.map((page, indice) => {
                            const activo = page.activo ? 'page-item active' : 'page-item';
                            return (
                              <li className={activo} key={indice}>
                                <a className="nav-link" href="#" onClick={(e)=>{e.preventDefault(); this.cargarCuentas(page.pagina);}}>{page.texto}</a>
                              </li>
                            );
                          })}
                        </ul>
                      </nav>
                    </div>
                  </React.Fragment>
                )}

              </div>
            </div>

          </div>
        </section>

        {/* ---------------------------------------------------- Modal: Crear ---------------------------------------------------- */}
        <div className="modal fade" id="modal-crear-cuenta-cobro" data-backdrop="static" tabIndex="-1" role="dialog" aria-hidden="true">
          <div className="modal-dialog">
            <div className="modal-content ccobro-modal">
              <div className="modal-header ccobro-modal__header">
                <h4 className="modal-title ccobro-modal__title"><i className="fas fa-plus-circle"></i> Crear cuenta de cobro</h4>
                <button type="button" className="close ccobro-modal__close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
              </div>
              <div className="modal-body ccobro-modal__body">
                <div className="form-group">
                  <label>Contrato <span className="ccobro-requerido">*</span></label>
                  <select className="form-control" name="idContrato" value={this.state.formCrear.idContrato} onChange={this.handleChangeCrear}>
                    <option value="">Seleccione...</option>
                    {this.state.contratos.map((c) => <option key={c.id} value={c.id}>{c.nombre}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Descripción</label>
                  <textarea className="form-control" rows="3" name="descripcion" value={this.state.formCrear.descripcion} onChange={this.handleChangeCrear}></textarea>
                </div>
              </div>
              <div className="modal-footer justify-content-between ccobro-modal__footer">
                <button type="button" className="btn btn-danger" data-dismiss="modal">Cerrar</button>
                <button type="button" className="btn btn-primary" disabled={this.state.guardandoCrear} onClick={this.guardarCrear}>
                  {this.state.guardandoCrear ? <i className="fas fa-circle-notch fa-spin"></i> : null} Crear
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* --------------------------------------------------- Modal: Detalle --------------------------------------------------- */}
        <div className="modal fade" id="modal-detalle-cuenta-cobro" data-backdrop="static" tabIndex="-1" role="dialog" aria-hidden="true">
          <div className="modal-dialog modal-xl modal-dialog-scrollable">
            <div className="modal-content ccobro-modal">
              <div className="modal-header ccobro-modal__header">
                <h4 className="modal-title ccobro-modal__title">
                  <i className="fas fa-file-invoice-dollar"></i> Cuenta de cobro {cuentaActual ? ('#' + this.campo(cuentaActual, ['id'])) : ''}
                </h4>
                <button type="button" className="close ccobro-modal__close" data-dismiss="modal" onClick={this.cerrarDetalle} aria-label="Close"><span aria-hidden="true">×</span></button>
              </div>
              <div className="modal-body ccobro-modal__body">

                {!cuentaActual ? (
                  <div className="ccobro-cargando"><ReactBootStrap.Spinner animation="border"/></div>
                ) : (
                  <React.Fragment>

                    <div className="ccobro-section">
                      <div className="row ccobro-row">
                        <div className="col-md-3">
                          <label>Estado</label>
                          <div>{this.renderBadgeEstado(estado)}</div>
                        </div>
                        <div className="col-md-3">
                          <label>Contrato</label>
                          <div className="ccobro-valor">{this.campo(cuentaActual, ['contrato.name', 'contrato.nombre', 'nombreContrato', 'contrato'], '-')}</div>
                        </div>
                        <div className="col-md-3">
                          <label>Fecha de creación</label>
                          <div className="ccobro-valor">{this.formatearFecha(this.campo(cuentaActual, ['fechaCreacion', 'fecha']), 'DD/MM/YYYY HH:mm')}</div>
                        </div>
                        <div className="col-md-3">
                          <label>Total facturas / valor</label>
                          <div className="ccobro-valor">
                            {this.campo(cuentaActual, ['totalFacturas', 'cantidadFacturas'], '0')}
                            {' — $ '}
                            {this.campo(cuentaActual, ['totalValor', 'valorTotal'], '0')}
                          </div>
                        </div>
                      </div>

                      <div className="row ccobro-row">
                        <div className="col-md-12">
                          <div className="ccobro-field-label-row">
                            <label>Descripción</label>
                            {puedeEditar && !this.state.editandoDescripcion ? (
                              <button type="button" className="ccobro-link-btn" onClick={this.iniciarEdicionDescripcion}><i className="fas fa-pen"></i> Editar</button>
                            ) : null}
                          </div>
                          {this.state.editandoDescripcion ? (
                            <React.Fragment>
                              <textarea className="form-control" rows="2" value={this.state.descripcionEdit} onChange={(e)=> this.setState({ descripcionEdit: e.target.value })}></textarea>
                              <div className="ccobro-editar-botones">
                                <button type="button" className="btn btn-sm btn-danger" onClick={()=> this.setState({ editandoDescripcion:false })}>Cancelar</button>
                                <button type="button" className="btn btn-sm btn-primary" disabled={this.state.guardandoEditar} onClick={this.guardarDescripcion}>
                                  {this.state.guardandoEditar ? <i className="fas fa-circle-notch fa-spin"></i> : null} Guardar
                                </button>
                              </div>
                            </React.Fragment>
                          ) : (
                            <div className="ccobro-valor">{this.campo(cuentaActual, ['descripcion'], 'Sin descripción')}</div>
                          )}
                        </div>
                      </div>
                    </div>

                    <ul className="nav nav-tabs ccobro-tabs">
                      <li className="nav-item">
                        <a href="#" className={"nav-link" + (this.state.tabDetalle==='facturas' ? ' active' : '')} onClick={(e)=>{e.preventDefault(); this.cambiarTabDetalle('facturas');}}>Facturas</a>
                      </li>
                      {puedeAgregarFacturas ? (
                        <li className="nav-item">
                          <a href="#" className={"nav-link" + (this.state.tabDetalle==='agregar' ? ' active' : '')} onClick={(e)=>{e.preventDefault(); this.cambiarTabDetalle('agregar');}}>Agregar facturas</a>
                        </li>
                      ) : null}
                      <li className="nav-item">
                        <a href="#" className={"nav-link" + (this.state.tabDetalle==='historial' ? ' active' : '')} onClick={(e)=>{e.preventDefault(); this.cambiarTabDetalle('historial');}}>Historial</a>
                      </li>
                    </ul>

                    {this.state.tabDetalle==='facturas' ? (
                      <div className="ccobro-tab-body">
                        {this.state.cargandoFacturasCuenta ? (
                          <div className="ccobro-cargando"><ReactBootStrap.Spinner animation="border" size="sm"/> <span>Cargando facturas...</span></div>
                        ) : this.state.facturasCuenta.length===0 ? (
                          <p className="ccobro-nota">Esta cuenta aún no tiene facturas agregadas.</p>
                        ) : (
                          <div className="table-responsive">
                            <table className="table table-sm ccobro-table">
                              <thead>
                                <tr>
                                  <th>Factura</th>
                                  <th>Fecha</th>
                                  <th>Valor</th>
                                  <th>Estado RIPS</th>
                                  <th>CUV</th>
                                  <th>Radicado</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.state.facturasCuenta.map((factura) => {
                                  const idDocumento = this.campo(factura, ['idDocumento', 'id']);
                                  return (
                                    <tr key={idDocumento}>
                                      <td>{this.campo(factura, ['factura', 'numeroFactura', 'prefijoNumero'], (this.campo(factura,['prefijo'],'') + '-' + this.campo(factura,['numero'],'')))}</td>
                                      <td>{this.formatearFecha(this.campo(factura, ['fecha', 'fechaFactura']))}</td>
                                      <td>$ {this.campo(factura, ['valorTotal', 'total'], '0')}</td>
                                      <td>{this.campo(factura, ['estadoRips', 'estado'], '-')}</td>
                                      <td>{this.campo(factura, ['cuv'], '-')}</td>
                                      <td>{this.campo(factura, ['numeroRadicado'], '-')}</td>
                                      <td className="text-right">
                                        {estado==='en-proceso' ? (
                                          <button type="button" className="ccobro-link-btn ccobro-link-btn--danger" disabled={this.state.quitandoFacturaId===idDocumento} onClick={()=> this.quitarFactura(idDocumento)}>
                                            {this.state.quitandoFacturaId===idDocumento ? <i className="fas fa-circle-notch fa-spin"></i> : <i className="fas fa-times"></i>} Quitar
                                          </button>
                                        ) : null}
                                      </td>
                                    </tr>
                                  );
                                })}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    ) : null}

                    {this.state.tabDetalle==='agregar' && puedeAgregarFacturas ? (
                      <div className="ccobro-tab-body">
                        <div className="ccobro-buscar-disponibles">
                          <input type="text" className="form-control" placeholder="Buscar por factura, identificación o nombre del paciente" value={this.state.textoBuscarDisponibles} onChange={(e)=> this.setState({ textoBuscarDisponibles: e.target.value })}/>
                          <button type="button" className="btn ccobro-btn-ghost" onClick={this.buscarFacturasDisponibles}><i className="fas fa-search"></i> Buscar</button>
                        </div>

                        {this.state.cargandoFacturasDisponibles ? (
                          <div className="ccobro-cargando"><ReactBootStrap.Spinner animation="border" size="sm"/> <span>Cargando facturas disponibles...</span></div>
                        ) : this.state.facturasDisponibles.length===0 ? (
                          <p className="ccobro-nota">No hay facturas disponibles para agregar con estos filtros.</p>
                        ) : (
                          <React.Fragment>
                            <div className="table-responsive">
                              <table className="table table-sm ccobro-table">
                                <thead>
                                  <tr>
                                    <th></th>
                                    <th>Factura</th>
                                    <th>Paciente</th>
                                    <th>Fecha</th>
                                    <th>Valor</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {this.state.facturasDisponibles.map((factura) => {
                                    const idDocumento = this.campo(factura, ['idDocumento', 'id']);
                                    return (
                                      <tr key={idDocumento}>
                                        <td><input type="checkbox" checked={this.state.facturasSeleccionadas.includes(idDocumento)} onChange={()=> this.toggleFacturaSeleccionada(idDocumento)}/></td>
                                        <td>{this.campo(factura, ['factura', 'numeroFactura', 'prefijoNumero'], (this.campo(factura,['prefijo'],'') + '-' + this.campo(factura,['numero'],'')))}</td>
                                        <td>{this.campo(factura, ['paciente.nombre', 'paciente', 'nombrePaciente'], '-')}</td>
                                        <td>{this.formatearFecha(this.campo(factura, ['fecha', 'fechaFactura']))}</td>
                                        <td>$ {this.campo(factura, ['valorTotal', 'total'], '0')}</td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>

                            <div className="ccobro-pagination-bar">
                              <span className="ccobro-pager-info">{this.state.pagerInfoFacturasDisponibles}</span>
                              <nav className="nav ccobro-pagination">
                                <ul className="pagination">
                                  {this.state.pagerFacturasDisponibles.map((page, indice) => {
                                    const activo = page.activo ? 'page-item active' : 'page-item';
                                    return (
                                      <li className={activo} key={indice}>
                                        <a className="nav-link" href="#" onClick={(e)=>{e.preventDefault(); this.cargarFacturasDisponibles(page.pagina);}}>{page.texto}</a>
                                      </li>
                                    );
                                  })}
                                </ul>
                              </nav>
                            </div>

                            <div className="text-right">
                              <button type="button" className="btn btn-primary" disabled={this.state.guardandoAgregarFacturas || this.state.facturasSeleccionadas.length===0} onClick={this.agregarFacturasSeleccionadas}>
                                {this.state.guardandoAgregarFacturas ? <i className="fas fa-circle-notch fa-spin"></i> : null} Agregar seleccionadas ({this.state.facturasSeleccionadas.length})
                              </button>
                            </div>
                          </React.Fragment>
                        )}
                      </div>
                    ) : null}

                    {this.state.tabDetalle==='historial' ? (
                      <div className="ccobro-tab-body">
                        {this.state.cargandoHistorial ? (
                          <div className="ccobro-cargando"><ReactBootStrap.Spinner animation="border" size="sm"/> <span>Cargando historial...</span></div>
                        ) : this.state.historialCuenta.length===0 ? (
                          <p className="ccobro-nota">Esta cuenta no tiene eventos registrados.</p>
                        ) : (
                          <ul className="ccobro-historial">
                            {this.state.historialCuenta.map((evento, indice) => (
                              <li key={indice}>
                                <span className="ccobro-historial__fecha">{this.formatearFecha(this.campo(evento, ['fecha']), 'DD/MM/YYYY HH:mm')}</span>
                                <span className="ccobro-historial__evento">{this.campo(evento, ['evento', 'accion', 'estado'], '-')}</span>
                                <span className="ccobro-historial__usuario">{this.campo(evento, ['usuario.nombre', 'usuario'], '-')}</span>
                                {this.campo(evento, ['observacion'], '') ? (
                                  <span className="ccobro-historial__observacion">{this.campo(evento, ['observacion'])}</span>
                                ) : null}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    ) : null}

                  </React.Fragment>
                )}

              </div>
              <div className="modal-footer justify-content-between ccobro-modal__footer">
                <button type="button" className="btn btn-danger" data-dismiss="modal" onClick={this.cerrarDetalle}>Cerrar</button>
                <div className="ccobro-acciones-estado">
                  {puedeCancelar ? <button type="button" className="btn ccobro-btn-ghost ccobro-btn-ghost--danger" onClick={this.abrirCancelar}><i className="fas fa-ban"></i> Cancelar cuenta</button> : null}
                  {puedeEnviar ? <button type="button" className="btn btn-primary" onClick={()=> $('#modal-enviar-cuenta-cobro').modal('show')}><i className="fas fa-paper-plane"></i> Enviar</button> : null}
                  {puedeRadicar ? <button type="button" className="btn btn-primary" onClick={this.abrirRadicar}><i className="fas fa-stamp"></i> Radicar</button> : null}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ---------------------------------------------------- Modal: Enviar --------------------------------------------------- */}
        <div className="modal fade" id="modal-enviar-cuenta-cobro" data-backdrop="static" tabIndex="-1" role="dialog" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content ccobro-modal">
              <div className="modal-header ccobro-modal__header">
                <h4 className="modal-title ccobro-modal__title"><i className="fas fa-paper-plane"></i> Enviar cuenta de cobro</h4>
              </div>
              <div className="modal-body ccobro-modal__body">
                <p className="ccobro-confirmar__pregunta">Se exige que todas las facturas sigan facturadas y tengan CUV. ¿Deseas continuar?</p>
                <div className="form-group">
                  <label>Observación (opcional)</label>
                  <textarea className="form-control" rows="2" value={this.state.observacionEnviar} onChange={(e)=> this.setState({ observacionEnviar: e.target.value })}></textarea>
                </div>
              </div>
              <div className="modal-footer justify-content-between ccobro-modal__footer">
                <button type="button" className="btn btn-danger" data-dismiss="modal">Cancelar</button>
                <button type="button" className="btn btn-primary" disabled={this.state.guardandoEnviar} onClick={this.enviarCuenta}>
                  {this.state.guardandoEnviar ? <i className="fas fa-circle-notch fa-spin"></i> : null} Enviar
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* --------------------------------------------------- Modal: Radicar --------------------------------------------------- */}
        <div className="modal fade" id="modal-radicar-cuenta-cobro" data-backdrop="static" tabIndex="-1" role="dialog" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content ccobro-modal">
              <div className="modal-header ccobro-modal__header">
                <h4 className="modal-title ccobro-modal__title"><i className="fas fa-stamp"></i> Radicar cuenta de cobro</h4>
              </div>
              <div className="modal-body ccobro-modal__body">
                <div className="form-group">
                  <label>Número de radicado <span className="ccobro-requerido">*</span></label>
                  <input type="text" className="form-control" name="numeroRadicado" value={this.state.formRadicar.numeroRadicado} onChange={this.handleChangeRadicar}/>
                </div>
                <div className="form-group">
                  <label>Fecha de radicado (si no se indica, se usa la de hoy)</label>
                  <input type="date" className="form-control" name="fechaRadicado" value={this.state.formRadicar.fechaRadicado} onChange={this.handleChangeRadicar}/>
                </div>
                <div className="form-group">
                  <label>Observación</label>
                  <textarea className="form-control" rows="2" name="observacion" value={this.state.formRadicar.observacion} onChange={this.handleChangeRadicar}></textarea>
                </div>
              </div>
              <div className="modal-footer justify-content-between ccobro-modal__footer">
                <button type="button" className="btn btn-danger" data-dismiss="modal">Cancelar</button>
                <button type="button" className="btn btn-primary" disabled={this.state.guardandoRadicar} onClick={this.confirmarRadicar}>
                  {this.state.guardandoRadicar ? <i className="fas fa-circle-notch fa-spin"></i> : null} Radicar
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* -------------------------------------------------- Modal: Cancelar --------------------------------------------------- */}
        <div className="modal fade" id="modal-cancelar-cuenta-cobro" data-backdrop="static" tabIndex="-1" role="dialog" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content ccobro-modal">
              <div className="modal-header ccobro-modal__header">
                <h4 className="modal-title ccobro-modal__title"><i className="fas fa-ban"></i> Cancelar cuenta de cobro</h4>
              </div>
              <div className="modal-body ccobro-modal__body">
                <p className="ccobro-confirmar__pregunta">Esta acción no se puede revertir. Solo es posible cancelar una cuenta sin facturas.</p>
                <div className="form-group">
                  <label>Motivo <span className="ccobro-requerido">*</span></label>
                  <textarea className="form-control" rows="3" value={this.state.motivoCancelar} onChange={(e)=> this.setState({ motivoCancelar: e.target.value })}></textarea>
                </div>
              </div>
              <div className="modal-footer justify-content-between ccobro-modal__footer">
                <button type="button" className="btn btn-secondary" data-dismiss="modal">Volver</button>
                <button type="button" className="btn btn-danger" disabled={this.state.guardandoCancelar} onClick={this.confirmarCancelar}>
                  {this.state.guardandoCancelar ? <i className="fas fa-circle-notch fa-spin"></i> : null} Cancelar cuenta
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default CuentasCobro;
